import { FILE_BASE_URL } from "../../config/env";

/**
 * Builds a direct object URL for a stored banner (or any uploaded) image key.
 *
 * Matches the API/signer layout: the key is URL-encoded and a `?versionId=`
 * (empty = latest) is appended, e.g.
 * `https://.../landing-content%2FTOP%20header%20baner%2F3---دوره---موبایل.webp?versionId=`
 */
export const getImageUrl = (key: string | null | undefined): string =>
  key ? `${FILE_BASE_URL}${encodeURIComponent(key)}?versionId=` : "";
